import { cn } from "@/lib/utils";
import PassIcon from "./PassIcon";

interface ChecklistItemProps {
  passed: boolean;
  children: React.ReactNode;
}

export default function ChecklistItem({
  passed,
  children,
}: ChecklistItemProps) {
  const defaultItemClassName = "flex py-1 pl-3";
  return (
    <li className={cn(defaultItemClassName, passed ? "text-green-600" : "")}>
      <PassIcon passed={passed} />
      {children}
    </li>
  );
}
